import React from 'react';
import PropTypes from 'prop-types';
import AreaCard from '@bd/bdui-areacard';
import { css } from '@bd/bdui-styles/emotion';
import { colors } from '../styles';

const styles = css`
  position: relative;
  transition: all .3s ease-out;
  &:hover {
    transition: all .3s ease-out;
    .AreaCard_name {
      background-image: none;
      background-color: ${colors.neutral};
      transition: all .3s ease-out;
    }

    .AreaCard_arrowIcon img {
      margin-right: -10px;
      transition: all .3s ease-out;
    }
  }
  .AreaCard_name {
    background-image: url('/images/cta-background-gradient.svg');
    background-size: cover;
    padding: 30px;
    font-weight: 700;
    font-size: 19px;
    line-height: 1;
    transition: all .3s ease-out;
  }
  .AreaCard_state {
    font-size: 13px;
    font-weight: 300;
    color: #8A8A8A;
  }
  a {
    color: #3F3F3F;
  }
  img {
    position: absolute;
    right: 20px;
    top: 25px;
  }
  .AreaCard_countWrapper {
    padding: 5px 30px;
    background-color: ${colors.brand2};
    font-size: 13px;
    font-weight: 700;
  }
  .AreaCard_count {
    padding: 0 15px 0 0;
    display: inline-block;
    color: #FFFFFF;
    &:last-child {
      padding: 0;
    }
  }
  .AreaCard_countValue {
    color: ${colors.brand1};
    margin: 0 0 0 0;
  }

  .AreaCard_countLabel {
    transition: all .3s ease-out;
    &:hover {
      color: ${colors.brand2};
      transition: all .3s ease-out;
    }
  }
  .AreaCard_arrowIcon img {
    transition: all .3s ease-out;
  }
`;

function StyledAreaCard({ area }) {
  return (
    <AreaCard
      area={area}
      arrowImage="/images/icon-circle-arrow.svg"
      className={styles}
      countPlansLabel="Floor Plans"
      getName={a => (
        <div>
          {a.name} <br /><span className="AreaCard_state" />
        </div>
      )}
      overrideStyles
    />
  );
}

StyledAreaCard.propTypes = {
  area: PropTypes.object.isRequired,
};

export default StyledAreaCard;



// WEBPACK FOOTER //
// ./src/components/AreaCard.js